export const SET_SCALE_STATE = 'SET_SCALE_STATE';

export default function setScaleState (scaleIndex, scaleData) {
    return {
      type: SET_SCALE_STATE,
      scaleIndex,
      scaleData
  }
}